import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type ParameterConfig } from '../services/deviceParameterService'

export interface ParameterConfigState {
  isLoading: boolean
  error: string | null
  httpStatus: number | null
  configs: ParameterConfig[]
}

const initialState: ParameterConfigState = {
  isLoading: true,
  error: null,
  httpStatus: null,
  configs: []
}

const parameterConfigSlice = createSlice({
  name: 'deviceParameters',
  initialState,
  reducers: {
    parameterConfigLoadingAction: (state) => {
      return {
        isLoading: true,
        error: null,
        httpStatus: 0,
        configs: []
      }
    },
    parameterConfigUpdateAction: (state, action: PayloadAction<{ data: ParameterConfig[], httpStatus: number }>) => {
      return {
        isLoading: false,
        error: null,
        httpStatus: action.payload.httpStatus,
        configs: action.payload.data
      }
    },
    parameterConfigErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        httpStatus: action.payload.httpStatus,
        configs: []
      }
    }
  }
})

export const {
  parameterConfigLoadingAction,
  parameterConfigUpdateAction,
  parameterConfigErrorAction
} = parameterConfigSlice.actions

export default parameterConfigSlice.reducer
